// DTM
import React from "react";
import styled from "styled-components";

import scale from "../helper/scaling";
import ArticleAbstract from "./ArticleAbstract";

const Wrapper = styled.div`
  width: 100%;
  float: left;

  @media (min-width: 1400px) {
    width: 1400px;
    padding: 0 calc(50% - 700px);
  }
  @media (max-width: 700px) {
    width: 100%;
    padding: 0;
  }
`;
const Inner = styled.div`
  width: calc(100% - 50px);
  margin: 0 25px 25px 25px;
  float: left;
  height: 100px;

  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;

  @media (max-width: 1100px) {
    height: ${scale(1100, 767, 100, 80, "vw")};
  }
  @media (max-width: 700px) {
    height: 80px;
    margin: 0 0 23px 0;
    width: 100%;
  }
`;

class MiniHeader extends ArticleAbstract {
  render() {
    return (
      <Wrapper>
        <Inner style={this.image()} />
      </Wrapper>
    );
  }
}

export default MiniHeader;



// WEBPACK FOOTER //
// ./src/components/MiniHeader.js